import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { StaffAuthzService } from './staff-authz.service';

/**
 * staff 관리 화면 진입 가드 — `canManageStaff()` 가 아니면 홈(`/`)으로 돌려보낸다. **UI 보호일 뿐**이다: 서버는 `StaffManagerGuard` 로 독립 거부한다.
 *
 * **`canMatch` 가 아니라 `canActivate` 로 쓴다.** `canMatch` 는 라우트 매칭 단계에서 평가되는데, `me` 는 부모 그룹의 `staffAuthGuard`(`canActivate`)가
 * `loadMe()` 를 끝내야 채워진다. 콜드 진입(직접 열기·새로고침)에서 `canMatch` 시점에는 `me` 가 비어 관리자도 홈으로 튕긴다.
 * 이 가드는 `staffAuthGuard` 를 가진 그룹의 자식 라우트에 둔다(부모 `canActivate` 가 먼저 끝난다).
 */
export const staffManagerGuard: CanActivateFn = () => {
  if (inject(StaffAuthzService).canManageStaff()) return true;
  return inject(Router).createUrlTree(['/']);
};
